$(document).ready(function() { 
  const headerSlideContentRef = $('[data-side-bg-color-slide-header]');

  headerSlideContentRef.each(function( index ) {
    let dataColor = $( this ).attr('data-side-bg-color-slide-header');
    $( this ).css('background-color', dataColor);
  });
});